import React from 'react';

import { Button, Tooltip } from '@mui/material';

import { classes } from './styles';

import type { Dispatch } from 'react';

import type { TableActionButtonProps, TableActionDrawerAction } from './types';

const ActionButton = ({
  action,
  dispatch,
  actionButtonId = '',
  actionCall = () => {},
  disabled = false
}: {
  action: TableActionButtonProps;
  dispatch: Dispatch<TableActionDrawerAction>;
  actionButtonId?: string;
  actionCall?: (() => void) | null;
  disabled?: boolean;
}): React.JSX.Element => {
  if (action.hidden) {
    return <React.Fragment key={action.id} />;
  }

  const isDisabled = disabled || !!action.disabled;
  const tooltipTitle = isDisabled && action.disabledTooltip ? action.disabledTooltip : '';

  const button = (
    <span>
      <Button
        disabled={isDisabled}
        id={actionButtonId ?? action.id}
        startIcon={action.icon}
        onClick={() => {
          if (isDisabled) return;

          dispatch?.({
            type: 'SET_ACTION_MODAL_OPEN',
            payload: { name: action.id, isOpen: true }
          });
          action.callback?.();
          actionCall?.();
        }}
        sx={{
          ...classes.selectAllWithActionsTooltipButton,
          ...(action.styles ?? {}),
          marginLeft: '5px'
        }}
      >
        {action.label}
      </Button>
    </span>
  );

  if (tooltipTitle) {
    return <Tooltip title={tooltipTitle}>{button}</Tooltip>;
  }

  return button;
};

export default ActionButton;
